/*
 * Cover value encoding.
 *
 * Persistence format for cover value:
 *   `<painting-id>`        — catalog cover by id
 *   `custom:<image-url>`   — user-uploaded photo
 *
 * Legacy values may include `::layout` / `::color` suffixes — those are
 * stripped on decode since the cover now has a single fixed layout.
 */

export const CUSTOM_PREFIX = 'custom:';

export const isCustomCover = (value: string | null | undefined): boolean =>
  !!value && value.startsWith(CUSTOM_PREFIX);

export const customUrlFromId = (paintingId: string): string =>
  isCustomCover(paintingId) ? paintingId.slice(CUSTOM_PREFIX.length) : '';

export const idFromCustomUrl = (url: string): string => `${CUSTOM_PREFIX}${url}`;

/** Encode painting id (or custom-prefixed url) into the persisted cover value. */
export const encodeCover = (paintingId: string): string => paintingId || '';

/** Decode a saved cover value back to its painting id. Strips legacy suffixes. */
export const decodeCover = (value: string | null | undefined): string => {
  if (!value) return '';
  return value.split('::')[0] || '';
};
